import React, { Component } from 'react'
import { TextArea } from 'semantic-ui-react'

export default class OpenText extends Component {
  state = { value: this.props.value || '' }

  componentDidUpdate(prevProps) {
    const { value } = this.props
    if (prevProps.value !== value) {
      this.setState({ value })
    }
  }

  handleChange = (_, { value = '' }) => {
    const { onChange } = this.props
    this.setState({ value })
    if (onChange) onChange(value)
  }

  render() {
    const { readOnly, textDirection } = this.props
    const { value } = this.state

    return (
      <TextArea
        dir={textDirection}
        name='value'
        onChange={this.handleChange}
        value={value}
        readOnly={readOnly}
      />
    )
  }
}
